import { fieldAlias, resolvePlainColumnAliases } from '../components/chartBuilder/LiveDatasetTable';

/** Etiquetas de cabecera cuando el alias SQL sanitiza caracteres (ej. Ocupación → Ocupaci_n). */
export function buildTableColumnLabelsFromSpec(tableColumns) {
  if (!Array.isArray(tableColumns) || !tableColumns.length) return undefined;
  const aliases = resolvePlainColumnAliases(tableColumns);
  const out = {};
  tableColumns.forEach((c, i) => {
    const custom = c?.alias && String(c.alias).trim();
    if (!custom) return;
    const key =
      aliases[i] ||
      fieldAlias(c, c.role === 'value' || c.fieldRole === 'value' ? `val_${i}` : `row_${i}`);
    if (!key || custom === key) return;
    out[key] = custom;
  });
  return Object.keys(out).length ? out : undefined;
}

export function resolveTableColumnLabels(chart) {
  const fromAdv = chart?.advancedConfig?.tableColumnLabels;
  if (fromAdv && typeof fromAdv === 'object' && Object.keys(fromAdv).length > 0) {
    return fromAdv;
  }
  return buildTableColumnLabelsFromSpec(chart?.visualizationSpec?.tableColumns);
}
